import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { formatError } from "@/lib/api";
import GoogleSignInButton from "@/components/app/GoogleSignInButton";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Kia ora, ${u.store_name || u.email}`);
      navigate(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <Card className="border-slate-200 shadow-lg">
        <CardHeader>
          <CardTitle className="font-display text-2xl">Welcome back</CardTitle>
          <CardDescription>Log in to post markdowns for your store.</CardDescription>
        </CardHeader>
        <CardContent>
          <GoogleSignInButton />
          <div className="my-4 flex items-center gap-2 text-xs text-slate-400"><div className="h-px bg-slate-200 flex-1"/>or use email<div className="h-px bg-slate-200 flex-1"/></div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required autoComplete="email" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required autoComplete="current-password" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-emerald-800 hover:bg-emerald-900 h-11" data-testid="login-submit">
              {loading ? "Logging in…" : "Log in"}
            </Button>
            <p className="text-sm text-slate-500 text-center">
              New store? <Link to="/register" className="text-emerald-800 font-semibold underline underline-offset-4">Register here</Link>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
